
/* CASTELLO DEL VINO – PDP ICON-HINWEISE V1.1 */

(() => {
  'use strict';

  const openers = new WeakMap();

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-cdv-notice-open]');

    if (trigger) {
      const dialog = document.getElementById(
        trigger.getAttribute('data-cdv-notice-open')
      );

      if (!dialog || dialog.tagName !== 'DIALOG') return;

      openers.set(dialog, trigger);

      if (!dialog.open) {
        dialog.showModal();
      }

      const rect = trigger.getBoundingClientRect();
      const dialogRect = dialog.getBoundingClientRect();

      const margin = 12;

      const left = Math.max(
        margin,
        Math.min(
          rect.left + rect.width / 2 - dialogRect.width / 2,
          window.innerWidth - dialogRect.width - margin
        )
      );

      const top = Math.max(
        margin,
        Math.min(
          rect.top + rect.height / 2 - 22,
          window.innerHeight - dialogRect.height - margin
        )
      );

      dialog.style.left = `${left}px`;
      dialog.style.top = `${top}px`;
      dialog.style.margin = '0';

      dialog.querySelector('[data-cdv-notice-close]')?.focus();
      return;
    }

    const closeButton = event.target.closest(
      '[data-cdv-notice-close]'
    );

    if (closeButton) {
      const dialog = closeButton.closest('dialog');

      if (dialog?.open) {
        dialog.close();
      }
    }
  });

  document.addEventListener('close', (event) => {
    const dialog = event.target;

    if (!dialog.matches('.cdv-pdp-notices__dialog')) return;

    dialog.style.left = '';
    dialog.style.top = '';
    dialog.style.margin = '';

    const opener = openers.get(dialog);

    if (opener?.isConnected) {
      opener.focus();
    }

    openers.delete(dialog);
  }, true);
})();
